module.exports = __webpack_public_path__ + "static/luciano-6bd10d2f413aadc1f4fa3c04974e42c9.png";